/**
 * True iff `year` is before `minDate` or after `maxDate`
 * @param {number} year The year to check
 * @param {Date} minDate The earliest date
 * @param {Date} maxDate The latest date
 */
export function yearOutsideRange(year, minDate, maxDate) {
  return year < minDate.getFullYear() || year > maxDate.getFullYear();
}
